export enum CustomerType {
  PROPERTYMANAGEMENT = 'PROPERTYMANAGEMENT',
  ESTATEAGENT = 'ESTATEAGENT',
  OTHER = 'OTHER',
  PRIVATE = 'PRIVATE'
}
